import { ApolloClient, InMemoryCache } from '@apollo/client'
import { split, HttpLink, from } from '@apollo/client'
import { getMainDefinition } from '@apollo/client/utilities'
import { WebSocketLink } from '@apollo/client/link/ws'
import { RetryLink } from '@apollo/client/link/retry'

const httpLink = new HttpLink({
  uri: process.env.HTTP_LINK,
})

const wsLink = new WebSocketLink({
  uri: process.env.WS_LINK as string,
  options: {
    reconnect: true,
  },
})

const links = from([
  new RetryLink({
    attempts: (count, operation, error) => {
      return error.toString() === 'TypeError: Failed to fetch' && count < 3
    },
  }),
  httpLink,
])

const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query)
    return definition.kind === 'OperationDefinition' && definition.operation === 'subscription'
  },
  wsLink,
  links,
)

export const client = new ApolloClient({
  link: splitLink,
  cache: new InMemoryCache({ addTypename: false }),
  defaultOptions: {
    query: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    },
    watchQuery: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    },
  },
})
